export enum InvestingStrategy {
  Balanced = 'balanced',
  Conservative = 'conservative',
  Defensive = 'defensive',
  Dynamic = 'dynamic',
}

export const strategiesMap = [
  {
    type: InvestingStrategy.Conservative,
    value: 1,
  },
  {
    type: InvestingStrategy.Defensive,
    value: 2,
  },
  {
    type: InvestingStrategy.Balanced,
    value: 3,
  },
  {
    type: InvestingStrategy.Dynamic,
    value: 4,
  },
];

export enum RPs {
  RP1 = 1,
  RP2 = 2,
  RP3 = 3,
  RP4 = 4,
}
